import { fetchWithAuth } from "../../../../api-client/api_client";
import { APIEndpointMethod, LinkedAccount } from "../../../../models/Entities";

interface Props {
  setIsLoadingTestLinkedAccounts: (isLoading: boolean) => void;
  setTestLinkedAccounts: (linkedAccounts: LinkedAccount[]) => void;
  setSelectedTestLinkedAccount: (linkedAccountID: string | undefined) => void;
}

const useFetchTestLinkedAccounts = ({
  setIsLoadingTestLinkedAccounts,
  setTestLinkedAccounts,
  setSelectedTestLinkedAccount,
}: Props) => {
  const fetchTestLinkedAccounts = (integrationID: string, category: string | null) => {
    setIsLoadingTestLinkedAccounts(true);
    const categoryFilter = category ? `?category=${category}` : "";
    return fetchWithAuth({
      path: `/integrations/${integrationID}/testable-linked-accounts${categoryFilter}`,
      method: APIEndpointMethod.GET,
      onResponse: (data: LinkedAccount[]) => {
        setIsLoadingTestLinkedAccounts(false);

        // Sort: non-merge orgs first, then by created_at descending within each group
        const sortedData = data.sort((a, b) => {
          const isMergeOrgDiff =
            Number(a.organization.is_merge_org) - Number(b.organization.is_merge_org);
          if (isMergeOrgDiff !== 0) return isMergeOrgDiff;
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });

        setTestLinkedAccounts(sortedData);

        if (sortedData.length > 0) {
          setSelectedTestLinkedAccount(sortedData[0].id);
        }
      },
      onError: () => {
        setIsLoadingTestLinkedAccounts(false);
      },
    });
  };
  return { fetchTestLinkedAccounts };
};

export default useFetchTestLinkedAccounts;
